$(function() {    

    // sets up manifesto animation controller
    if ($('#modalManifesto').length) { 
        var controllerManifesto = new ScrollMagic.Controller({
            container: "#modalManifesto .manifesto-body"
        });
    }

    // open fullscreen manifesto modal
    $('#blockPurpose .btn-primary').on('click', function(e) {
        e.preventDefault();
        
        $('#modalManifesto .manifesto-body')
            .animate({
                scrollTop: 0
            }, 'fast');
        $('body')
            .addClass('no-scroll')
            .addClass('manifesto-opening')
        $('.site-wrapper')
            .addClass('manifesto-transform');
        $('#modalManifesto')
            .addClass('modal-open')
            .removeClass('modal-closed')
            .attr('aria-modal', 'true')
            .removeAttr('aria-hidden')

        setTimeout(function() {
            $('#modalManifesto')
                .addClass('modal-expanded').resize()
            $('.site-wrapper')
                .removeClass('manifesto-transform');
            $('body')
                .addClass('manifesto-open')
        }, 3000);

        setTimeout(function() {
            $('.js-manifesto-arrow')
                .addClass('is-visible')
        }, 3500);

    });


    // close manifesto modal
    $('.js-modal-close').on('click', function() {
        $('body')
            .removeClass('no-scroll')
            .addClass('manifesto-closing')
        $('#modalManifesto')
            .attr('aria-hidden', 'true')
            .removeAttr('aria-modal');

        setTimeout(function() {
            $('#modalManifesto')
                .removeClass('modal-expanded')
                .removeClass('modal-open')
            $('.js-manifesto-arrow')
                .removeClass('is-visible')
            $('body')
                .removeClass('manifesto-open')
        }, 1000);
        setTimeout(function() {
            $('body')
                .removeClass('manifesto-closing')
        }, 2000);
    });
    

    // manifesto scrolll progress
    $('#modalManifesto .manifesto-body').on('scroll', function() {
        $this = $(this);
        var scroll        = $(this).scrollTop();
        var scrollHeight = $(this).get(0).scrollHeight;
        var height        = $(this).height ();
        var percent       = scroll / (scrollHeight - height) * 100;
        var stickyButton = $('.js-sticky-cta-button');

        $('.manifesto-progress .progress-bar')
        .attr('aria-valuenow', percent)
        .css("width", percent + "%");
    });


    // fade logos in sequentially, once block is in view
    $('.js-logo-element').each(function(e) {
        var scene = new ScrollMagic.Scene({
            duration: 0,
            reverse: false,
            triggerElement: this,
            triggerHook: 0.6,
        })
        .on("enter", function(e) {
            logoFadeIn();
        })
        .addTo(controllerManifesto);
    });
    function logoFadeIn() {
        var tl = new TimelineMax({
            repeat: false,
            reverse: false,
            triggerElement: '#logoBlock'
        })
        var elementLogo = $(".js-logo-element").toArray()
        elementLogo.sort(function() {
            return 0.4-Math.random()
        });

        tl.staggerTo(elementLogo, 0, {
            className: "+=in-view"
        }, 1);
    }


    // simple underline animation
    $('.js-manifesto-underline').each(function() {
        $this = $(this);

        $this.append('<object type="image/svg+xml" data="/assets/images/scribbles/animated/scribble-underline-heading.svg" height="15" width="415">Hand drawn underline</object>')

        var scene = new ScrollMagic.Scene({
            duration: 0,
            reverse: false,
            triggerElement: this,
            triggerHook: .8,
        })
        .setClassToggle(this, "in-view")
        .addTo(controllerManifesto);
    });


    // complex underline animation
    $('.js-manifesto-scribble').each(function() {
        $this = $(this);

        $this.append('<object type="image/svg+xml" data="/assets/images/scribbles/animated/scribble-underline-manifesto-complex.svg" height="27" width="386">Hand drawn underline</object>')

        var scene = new ScrollMagic.Scene({
            duration: 0,
            reverse: false,
            triggerElement: this,
            triggerHook: .8,
        })
        .setClassToggle(this, "in-view")
        .addTo(controllerManifesto);
    });


    // fade in sun image
    $('#manifestoHeader').each(function() {

        // build tween
        var manifestoPinSun = new TimelineMax()
            .to(".manifesto-sun", 1, {
                y: "-100%", ease: Linear.easeInOut,
            }, 0)

        // build scene
        var scene = new ScrollMagic.Scene({
            duration: '50%',
            triggerElement: this,
            triggerHook: 0,
        })
        .setTween(manifestoPinSun)
        .addTo(controllerManifesto);
    });


    // pin card when scrolled into view
    $('.js-manifesto-pin').each(function() {
        $this = $(this);
        const tween = new TimelineMax();
        var manifestoCard = $this.find('.manifesto-card');

        // build tween
        var manifestoPin1 = new TimelineMax()

            // transition sun back down in preparation for fade in
            .to('.manifesto-sun ', 1, {
                autoAlpha: 0,
            }, 1)

            // fade in manifesto card
            .fromTo(manifestoCard, 0, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, ease: Linear.easeInOut,
            }, 1)

            // scroll first panel up
            .fromTo(".panel-1", .5, {
                autoAlpha: 1,
                y: "100%", ease: Linear.easeInOut,
            }, {
                autoAlpha: 1,
                y: "0%", ease: Linear.easeInOut,
            }, 2)
            .to(".panel-1", 1, {
                autoAlpha: 1,
            }, 37)
            .fromTo(".panel-1", 1, {
                autoAlpha: 1,
            }, {
                autoAlpha: 0, ease: Linear.easeInOut,
            }, 47)

            // scroll second panel up
            .fromTo(".panel-2", .5, {
                autoAlpha: 1,
                y: "100%", ease: Linear.easeInOut,
            }, {
                autoAlpha: 1,
                y: "0%", ease: Linear.easeInOut,
            }, 67)
            .to(".panel-2", 1, {
                autoAlpha: 1,
            }, 102)
            .fromTo(".panel-2", 1, {
                autoAlpha: 1,
            }, {
                autoAlpha: 0, ease: Linear.easeInOut,
            }, 112)

            // scroll third panel up
            .fromTo(".panel-3", .5, {
                autoAlpha: 1,
                y: "100%", ease: Linear.easeInOut,
            }, {
                autoAlpha: 1,
                y: "0%", ease: Linear.easeInOut,
            }, 132)
            .to(".panel-3", 1, {
                autoAlpha: 1,
            }, 177)

            // transition sun back down in preparation for fade in
            .to('.manifesto-sun ', 1, {
                autoAlpha: 0,
                y: "0%",
                scale: .5,
            }, 177)

        // build scene
        var scene = new ScrollMagic.Scene({
            duration: '400%',
            triggerElement: this,
            triggerHook: 0,
        })
        .setPin(this, "js-manifesto-pin")
        .setTween(manifestoPin1)
        .addTo(controllerManifesto);

        // destroy on mobile
        function pinBreakpoints() {
            var w = window.innerWidth;

            if (w < 992) {
                scene.enabled(false);
            } else {
                scene.enabled(true);
            }
        }
        $(window).resize(pinBreakpoints);
        pinBreakpoints();

    });


    // fixed background (dark clouds)
    $('.js-clouds-dark').each(function() {
        const tween = new TimelineMax();

        // build tween
        var manifestoPinBg = new TimelineMax()
            .fromTo(".js-clouds-dark", 1, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, ease: Linear.easeInOut,
            }, 0)

        // build scene
        var scene = new ScrollMagic.Scene({
            duration: '80%',
            triggerElement: '.js-manifesto-pin2',
            triggerHook: 'onEnter',
        })
        .setTween(manifestoPinBg)
        .addTo(controllerManifesto);

        // destroy on mobile
        function pinBreakpoints() {
            var w = window.innerWidth;

            if (w < 992) {
                scene.enabled(false);
            } else {
                scene.enabled(true);
            }
        }
        $(window).resize(pinBreakpoints);
        pinBreakpoints();
    });


    // pin card when scrolled into view
    $('.js-manifesto-pin2').each(function() {
        $this = $(this);
        const tween = new TimelineMax();
        var manifestoCard = $this.find('.manifesto-card');

        // build tween
        var manifestoPin2 = new TimelineMax()

            // fade in manifesto card
            .fromTo(manifestoCard, 0, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, ease: Linear.easeInOut,
            }, 1)

            // scroll first panel up
            .fromTo(".panel-4", .5, {
                autoAlpha: 1,
                y: "100%", ease: Linear.easeInOut,
            }, {
                autoAlpha: 1,
                y: "0%", ease: Linear.easeInOut,
            }, 2)
            .to(".panel-4", 1, {
                autoAlpha: 1,
            }, 37)
            .fromTo(".panel-4", 1, {
                autoAlpha: 1,
            }, {
                autoAlpha: 0, ease: Linear.easeInOut,
            }, 47)

            // scroll second panel up
            .fromTo(".panel-5", .5, {
                autoAlpha: 1,
                y: "100%", ease: Linear.easeInOut,
            }, {
                autoAlpha: 1,
                y: "0%", ease: Linear.easeInOut,
            }, 67)
            .to(".panel-5", 1, {
                autoAlpha: 1,
            }, 102)
            .fromTo(".panel-5", 1, {
                autoAlpha: 1,
            }, {
                autoAlpha: 0, ease: Linear.easeInOut,
            }, 112)

            // scroll third panel up
            .fromTo(".panel-6", .5, {
                autoAlpha: 1,
                y: "100%", ease: Linear.easeInOut,
            }, {
                autoAlpha: 1,
                y: "0%", ease: Linear.easeInOut,
            }, 132)
            .to(".panel-6", 1, {
                autoAlpha: 1,
            }, 167)
            .fromTo(".panel-6", 1, {
                autoAlpha: 1,
            }, {
                autoAlpha: 0, ease: Linear.easeInOut,
            }, 177)

            // scroll fourth panel up
            .fromTo(".panel-7", .5, {
                autoAlpha: 1,
                y: "100%", ease: Linear.easeInOut,
            }, {
                autoAlpha: 1,
                y: "0%", ease: Linear.easeInOut,
            }, 197)
            .to(".panel-7", 1, {
                autoAlpha: 1,
            }, 297)

            .to('.manifesto-sun ', 1, {
                autoAlpha: '.5', ease: Linear.easeInOut,
                y: "0%",
                scale: 1, ease: Linear.easeInOut,
            }, 247)

        // build scene
        var scene = new ScrollMagic.Scene({
            duration: '400%',
            triggerElement: this,
            triggerHook: 0,
        })
        .setPin(this, "js-manifesto-pin2")
        .setTween(manifestoPin2)
        .addTo(controllerManifesto);

        // destroy on mobile
        function pinBreakpoints() {
            var w = window.innerWidth;

            if (w < 992) {
                scene.enabled(false);
            } else {
                scene.enabled(true);
            }
        }
        $(window).resize(pinBreakpoints);
        pinBreakpoints();
    });


    // fixed background (dark clouds)
    $('.js-manifesto-pin20').each(function() {
        const tween = new TimelineMax();

        // build tween
        var manifestoUnpinBg = new TimelineMax()
            
            // fade out cloudy background
            .to('.js-clouds-dark', 1, {
                autoAlpha: 0, ease: Linear.easeInOut,
            }, 0)

        // build scene
        var scene = new ScrollMagic.Scene({
            duration: '80%',
            triggerElement: this,
            triggerHook: 'onEnter',
        })
        //.setPin(this, "js-manifesto-bg-fixed")
        .setTween(manifestoUnpinBg)
        .addTo(controllerManifesto);

        // destroy on mobile
        function pinBreakpoints() {
            var w = window.innerWidth;

            if (w < 992) {
                scene.enabled(false);
            } else {
                scene.enabled(true);
            }
        }
        $(window).resize(pinBreakpoints);
        pinBreakpoints();
    });


    // pin card when scrolled into view
    $('.js-manifesto-pin20').each(function() {
        const tween = new TimelineMax();

        // build tween
        var manifestoPin20 = new TimelineMax()

            .to('.manifesto-sun ', 1, {
                autoAlpha: '0', ease: Linear.easeInOut,
                y: "0%",
                scale: .5, ease: Linear.easeInOut,
            }, 0)

            .fromTo('.js-panel-1', 1, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, ease: Linear.easeInOut,
            }, 1)
            .to('.js-panel-1', .5, {
                autoAlpha: .65,
            }, 10)

            .fromTo('.js-panel-2', 0, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, ease: Linear.easeInOut,
            }, 10)
            .to('.js-panel-2 .text-underline-heading', 0, {
                className: "+=is-visible"
            }, 10)

            .fromTo('.js-panel-3', 0, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, ease: Linear.easeInOut,
            }, 20)
            .to('.js-panel-3', 0, {
                autoAlpha: 1,
            }, 30)
            .to('.js-panel-3', .5, {
                autoAlpha: .65,
            }, 30)

            .fromTo('.js-panel-4', 0, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, ease: Linear.easeInOut,
            }, 30)
            .to(".js-panel-4", 1, {
                autoAlpha: 1,
            }, 35)
            .to('.js-panel-4 .text-underline-heading', 0, {
                className: "+=is-visible"
            }, 30)

        // build scene
        var scene = new ScrollMagic.Scene({
            duration: '400%',
            triggerElement: this,
            triggerHook: 0,
        })
        .setPin(this, "js-manifesto-pin20")
        .setTween(manifestoPin20)
        .addTo(controllerManifesto);

        // destroy on mobile
        function pinBreakpoints() {
            var w = window.innerWidth;

            if (w < 992) {
                scene.enabled(false);
            } else {
                scene.enabled(true);
            }
        }
        $(window).resize(pinBreakpoints);
        pinBreakpoints();
    });


    // pin card when scrolled into view
    $('.js-manifesto-pin3').each(function() {
        $this = $(this);
        const tween = new TimelineMax();
        var manifestoCard = $this.find('.manifesto-card');

        // build tween
        var manifestoPin3 = new TimelineMax()

            // fade in manifesto card
            .fromTo(".js-manifesto-pin3 .col-square:first-child .manifesto-card", 0, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, ease: Linear.easeInOut,
            }, 1)

             // scroll first panel up
            .fromTo(".panel-8", .5, {
                autoAlpha: 1,
                y: "100%", ease: Linear.easeInOut,
            }, {
                autoAlpha: 1,
                y: "0%", ease: Linear.easeInOut,
            }, 2)
            .to(".panel-8", 1, {
                autoAlpha: 1,
            }, 37)

            // fade in manifesto card
            .fromTo(".js-manifesto-pin3 .col-square:last-child .manifesto-card", 0, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, ease: Linear.easeInOut,
            }, 42)


            .fromTo(".panel-9", .5, {
                autoAlpha: 1,
                y: "100%", ease: Linear.easeInOut,
            }, {
                autoAlpha: 1,
                y: "0%", ease: Linear.easeInOut,
            }, 43)
            .to(".panel-9", 1, {
                autoAlpha: 1,
            }, 58)
            .to(".js-blue-fadeout", 1, {
                autoAlpha: 0,
            }, 78)
            .fromTo(".panel-9", 1, {
                autoAlpha: 1,
            }, {
                autoAlpha: 0, ease: Linear.easeInOut,
            }, 108)
            .fromTo(".js-manifesto-crossfade", 1, {
                backgroundColor: '#009900', ease: Linear.easeInOut,
            }, {
                backgroundColor: 'transparent', ease: Linear.easeInOut,
            }, 108)

            .fromTo(".js-new-1", .5, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1,
            }, 158)
            .to(".js-new-1", 1, {
                autoAlpha: 1,
            }, 168)

            .fromTo(".js-new-2", .5, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1,
            }, 188)
            .to('.js-new-2', .5, {
                autoAlpha: 1,
            }, 198)
            .to('.js-new-1', .5, {
                autoAlpha: .65,
            }, 198)

            .fromTo(".js-panel-5", .5, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1,
            }, 218)
            .to('.js-new-2', .5, {
                autoAlpha: .65,
            }, 218)
            .to('.js-panel-5 .text-underline-heading', 0, {
                className: "+=is-visible"
            }, 218)
            .to('.js-panel-5', .5, {
                autoAlpha: 1,
            }, 238)


        // build scene
        var scene = new ScrollMagic.Scene({
            duration: '400%',
            triggerElement: this,
            triggerHook: 0,
        })
        .setPin(this, "js-manifesto-pin3")
        .setTween(manifestoPin3)
        .addTo(controllerManifesto);

        // destroy on mobile
        function pinBreakpoints() {
            var w = window.innerWidth;

            if (w < 992) {
                scene.enabled(false);
            } else {
                scene.enabled(true);
            }
        }
        $(window).resize(pinBreakpoints);
        pinBreakpoints();
    });


    // pin card when scrolled into view
    $('.js-manifesto-pin5').each(function() {
        $this = $(this);
        const tween = new TimelineMax();
        var manifestoCard = $this.find('.manifesto-card');

        // build tween
        var manifestoPin5 = new TimelineMax()

            .fromTo('.js-panel-7', 0, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, ease: Linear.easeInOut,
            }, 1)
            .to('.js-panel-7', .5, {
                autoAlpha: .65,
            }, 10)

            .fromTo('.js-panel-8', 0, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, ease: Linear.easeInOut,
            }, 10)
            .to('.js-panel-8 .text-underline-heading', 0, {
                className: "+=is-visible"
            }, 10)

            .fromTo('.js-panel-9', 0, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, ease: Linear.easeInOut,
            }, 20)
            .to('.js-panel-9', .5, {
                autoAlpha: .65,
            }, 30)

            .fromTo('.js-panel-10', 0, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, ease: Linear.easeInOut,
            }, 30)
            .to(".js-panel-10", 1, {
                autoAlpha: 1,
            }, 35)
            .to('.js-panel-10 .text-underline-heading', 0, {
                className: "+=is-visible"
            }, 30)

        // build scene
        var scene = new ScrollMagic.Scene({
            duration: '400%',
            triggerElement: this,
            triggerHook: 0,
        })
        .setPin(this, "js-manifesto-pin5")
        .setTween(manifestoPin5)
        .addTo(controllerManifesto);

        // destroy on mobile
        function pinBreakpoints() {
            var w = window.innerWidth;

            if (w < 992) {
                scene.enabled(false);
            } else {
                scene.enabled(true);
            }
        }
        $(window).resize(pinBreakpoints);
        pinBreakpoints();
    });


    // pin card when scrolled into view
    $('.js-manifesto-pin6').each(function() {
        $this = $(this);
        const tween = new TimelineMax();
        var manifestoCard = $this.find('.manifesto-card');

        // build tween
        var manifestoPin6 = new TimelineMax()

            // image 2
            .to('.js-manifesto-bg-2', 0, {
                className: "+=is-visible"
            }, 1)

            // fade in manifesto card
            .fromTo(manifestoCard, 0, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, ease: Linear.easeInOut,
            }, 1)


            // entire panel / first string of text
            .fromTo(".panel-12", .5, {
                autoAlpha: 1,
                y: "100%", ease: Linear.easeInOut,
            }, {
                autoAlpha: 1,
                y: "0%", ease: Linear.easeInOut,
            }, 2)
            .to(".panel-12", 1, {
                autoAlpha: 1,
            }, 47)


            // panel 1 / 2nd string of text
            .fromTo('.js-panel-11', .5, {
                autoAlpha: 1,
            }, {
                autoAlpha: .65, ease: Linear.easeInOut,
            }, 67)
            .to('.js-manifesto-bg-3', 0, {
                className: "+=is-visible"
            }, 67)
            .fromTo('.js-panel-12', 0, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1, ease: Linear.easeInOut,
            }, 67)
            .to(".js-panel-12", 1, {
                autoAlpha: 1,
            }, 102)


            // fade out entire 1st panel
            .fromTo(".panel-12", 1, {
                autoAlpha: 1,
            }, {
                autoAlpha: 0, ease: Linear.easeInOut,
            }, 112)


            // slide in 2nd panel
            .to('.js-manifesto-bg-4', 0, {
                className: "+=is-visible"
            }, 132)
            .fromTo(".panel-13", .5, {
                autoAlpha: 1,
                y: "100%", ease: Linear.easeInOut,
            }, {
                autoAlpha: 1,
                y: "0%", ease: Linear.easeInOut,
            }, 132)
            .to(".panel-13", 1, {
                autoAlpha: 1,
            }, 167)
            .fromTo(".panel-13", 1, {
                autoAlpha: 1,
            }, {
                autoAlpha: 0, ease: Linear.easeInOut,
            }, 177)


            // slide in 3rd panel
            .to('.js-manifesto-bg-5', 0, {
                className: "+=is-visible"
            }, 197)
            .fromTo(".panel-14", .5, {
                autoAlpha: 1,
                y: "100%", ease: Linear.easeInOut,
            }, {
                autoAlpha: 1,
                y: "0%", ease: Linear.easeInOut,
            }, 197)
            .to(".panel-14", 1, {
                autoAlpha: 1,
            }, 232)
            .fromTo(".panel-14", 1, {
                autoAlpha: 1,
            }, {
                autoAlpha: 0, ease: Linear.easeInOut,
            }, 242)


            // slide in 4th panel
            .to('.js-manifesto-bg-6', 0, {
                className: "+=is-visible"
            }, 262)
            .fromTo(".panel-15", .5, {
                autoAlpha: 1,
                y: "100%", ease: Linear.easeInOut,
            }, {
                autoAlpha: 1,
                y: "0%", ease: Linear.easeInOut,
            }, 262)
            .to(".panel-15", 1, {
                autoAlpha: 1,
            }, 297)
            .fromTo(".panel-15", 1, {
                autoAlpha: 1,
            }, {
                autoAlpha: 0, ease: Linear.easeInOut,
            }, 307)

            .fromTo(".js-panel-final-1", .5, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1,
            }, 342)
            .to('.js-manifesto-bg-7', 0, {
                className: "+=is-visible"
            }, 342)
            .to(manifestoCard, 1, {
                autoAlpha: 0,
            }, 342)


            .fromTo(".js-panel-final-2", .5, {
                autoAlpha: 0,
            }, {
                autoAlpha: 1,
            }, 377)
            .to('.js-panel-final-2 .in-view', 0, {
                className: "+=is-visible"
            }, 377)
            .to('.js-manifesto-bg-8', 0, {
                className: "+=is-visible"
            }, 377)
            .to(manifestoCard, 1, {
                autoAlpha: 0,
            }, 377)


        // build scene
        var scene = new ScrollMagic.Scene({
            duration: '400%',
            triggerElement: this,
            triggerHook: 0,
        })
        .setPin(this, "js-manifesto-pin6")
        .setTween(manifestoPin6)
        .addTo(controllerManifesto);

        // destroy on mobile
        function pinBreakpoints() {
            var w = window.innerWidth;

            if (w < 992) {
                scene.enabled(false);
            } else {
                scene.enabled(true);
            }
        }
        $(window).resize(pinBreakpoints);
        pinBreakpoints();
    });

    // dynamically position animated arrow
    scribbleArrow = function() {
        if ($('.js-manifesto-arrow').length) {
            
            // manifesto header
            var elementHeader = $('#manifestoHeader');
            var elementHeaderBottom = elementHeader.position().top + elementHeader.outerHeight(true);

            // manifesto header copy
            var elementContent = $('.js-manifesto-arrow-src');
            var elementContentHeight = elementContent.outerHeight();
            var elementContentWidth = elementContent.outerWidth() / 3;
            var elementContentBottom = elementContent.position().top + elementContent.outerHeight(true);
            
            var elementContentLeft = elementContent.offset().left + elementContentWidth;

            // manifesto header copy position
            var elementContentPosition = $('.js-manifesto-arrow-src').offset().top;

            // manifesto arrow height
            var elementArrowHeight = elementHeaderBottom - elementContentBottom;

            // manifesto arrow
            $('.js-manifesto-arrow').css({
                bottom: elementHeaderBottom + 50,
                height: elementArrowHeight - 100,
                left: elementContentLeft,
                top: elementContentBottom + 50,
            });

        }
    };

    scribbleArrow();

});

$(window).resize(function() {
    setTimeout(function() {
        scribbleArrow();
    }, 200);
});
